import React, {Fragment, Component} from 'react';
import {Link, Route, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {actions as project} from '../../reducers/project';
import RestrictedToAdmin from '../general/RestrictedToAdmin';
import {Form, Formik} from 'formik';
import Select from '../form/Select';
import {actions as system} from "../../reducers/system";
import LabelSearch from "../../screens/LabelSearch";

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			selectedLabelCollection: state.labelCollection.selected
		}
	},
	dispatch => {
		return {
			clearMessages: () => dispatch(system.clearMessages()),
			importProject: projectObject => dispatch(project.import(projectObject)),
			renderProject: projectObject => dispatch(project.render(projectObject)),
			replaceDefaultLanguageInAllCollections: (oldLanguage, newLanguage) => dispatch(project.replace(oldLanguage, newLanguage))
		}
	}
)
class Navbar extends Component {

	render() {
		return (
			<nav className="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
				<div className="container-fluid">
					<div className="navbar-wrapper">
						<div className="navbar-minimize">
							<button id="minimizeSidebar" className="btn btn-icon">
								<i className="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"/>
								<i className="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"/>
							</button>
						</div>

						{this.renderBreadcrumb()}
					</div>
                    <div className='collapse navbar-collapse justify-content-end'>
                        {this.props.selectedProject?<LabelSearch/>:null}
                    </div>
                    <div className='collapse navbar-collapse justify-content-end'>
                        {this.renderMenu()}
                    </div>
					{this.renderLogout()}
				</div>
				{this.renderReplaceModal()}
			</nav>
		);
	}

	renderLogout() {
		return (
			<div>
				<a href={window.logout} className={"btn btn-primary text-white"}>logout</a>
			</div>
		);
	}

	render

	renderReplaceModal() {
		const initialState = {
			oldLanguage: '',
			newLanguage: ''
		};

		return (
			<div id="replace-modal-project" className="modal">
				<div className="modal-dialog modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h1>Replace default language in collections</h1>
						</div>
						<div className="modal-body">
							{
								this.props.selectedProject ? (
									<Formik
										initialValues={initialState}
										onSubmit={(project, actions) => {
											this.props.clearMessages();
											this.props.replaceDefaultLanguageInAllCollections(project.oldLanguage, project.newLanguage)
												.then(
													success => {
														if(success) {
															actions.setSubmitting(false);
														} else {
															actions.setSubmitting(false);
														}
													}
												);
										}}
										render={({ isSubmitting }) => (
											<Form>
												<div className="form-group">
													<label>Default language to be replaced: </label>
													<Select name="oldLanguage" placeholder="Select..." options={
														this.props.selectedProject.languages.map(language => (
															{value: language, label: language}
														))
													}/>
												</div>
												<div className="form-group">
													<label>New default language:</label>
													<Select name="newLanguage" placeholder="Select..." options={
														this.props.selectedProject.languages.map(language => (
															{value: language, label: language}
														))
													}/>
												</div>
												<div>
													<input className="btn btn-primary" type="submit" value="save" disabled={isSubmitting} data-target="#replace-modal-project" data-toggle="modal"/>
												</div>
											</Form>
										)}
									/>
								) : null
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderBreadcrumb() {
		return (
			<div className="navbar-brand">
				<Link to="/">Translation Tool</Link>
				{this.props.selectedProject ? (
					<Fragment> / <Link to={'/show/' + encodeURIComponent(this.props.selectedProject.name)}>{this.props.selectedProject.name}</Link></Fragment>
				): null}
				{this.props.selectedLabelCollection ? (
					<Fragment> / {this.props.selectedLabelCollection.displayName ?
						this.props.selectedLabelCollection.displayName : this.props.selectedLabelCollection.genericDisplayName}</Fragment>
				): null}
			</div>
		);
	}

	renderMenu() {
		return (
			<Fragment>
				<Route exact path="/" render={() =>
					<RestrictedToAdmin>
						{
							this.renderMenuWithItems(
								<Fragment>
									<Link to="/create-project" className="dropdown-item">Create Project</Link>
									<Link to="/languages" className="dropdown-item">Manage Languages</Link>
								</Fragment>
							)
						}
					</RestrictedToAdmin>
				}/>
				<Route exact path="/show/:project" render={() =>
					<RestrictedToAdmin>
						{
							this.props.selectedProject && this.renderMenuWithItems(
								<Fragment>
										<Link to={'/create-labelCollection/' + encodeURIComponent(this.props.selectedProject.name)} className="dropdown-item">Add collection to "{this.props.selectedProject.name}"</Link>
										<Link to={'/code-Scanner/' + encodeURIComponent(this.props.selectedProject.name)} className="dropdown-item">Code-Scan "{this.props.selectedProject.name}"</Link>
										<a className="dropdown-item" data-target="#import-modal-project" data-toggle="modal">Import "{this.props.selectedProject.name}"</a>
										<Link to={'/edit/' + encodeURIComponent(this.props.selectedProject.name)} className="dropdown-item">Edit "{this.props.selectedProject.name}"</Link>
										<a className='dropdown-item' data-target="#render-modal-project" data-toggle="modal">Render all labels</a>
										<a className='dropdown-item' data-target="#replace-modal-project" data-toggle="modal">Replace default language in collections</a>
										<a className="dropdown-item" data-target="#delete-modal-project" data-toggle="modal">Delete "{this.props.selectedProject.name}"</a>
										<Link to="/create-project" className="dropdown-item">Create Project</Link>
										<Link to={'/export-project/' + encodeURIComponent(this.props.selectedProject.name)} className="dropdown-item">Export Translations as XLSX</Link>
										<Link to={'/import-project/' + encodeURIComponent(this.props.selectedProject.name)} className="dropdown-item">Import Translations from XLSX</Link>
										<Link to="/languages" className="dropdown-item">Manage Languages</Link>
									</Fragment>
							)
						}
					</RestrictedToAdmin>

				}/>
				<Route exact path="/languages" render={() =>
					<RestrictedToAdmin>
						{
							this.renderMenuWithItems(
								<Link to="/create-language" className="dropdown-item">Create Language</Link>
							)
						}
					</RestrictedToAdmin>
				}/>
				<Route exact path="/show/:project/:labelCollection" render={() => {
					return this.props.selectedProject && this.props.selectedLabelCollection ? (
						<RestrictedToAdmin>
							<ul className="navbar-nav">
								<li className="nav-item dropdown">
									<Link
										to={'/create-label/' + encodeURIComponent(this.props.selectedProject.name) + '/' + encodeURIComponent(this.props.selectedLabelCollection.identifier)}
										className="nav-link">
										<i className="fa fa-plus"/>
									</Link>
								</li>
							</ul>
						</RestrictedToAdmin>
					) : null
				}}/>
			</Fragment>
		);
	}

	renderMenuWithItems(items) {
		return (
			<div className='navbar-nav' id="navigation">
				<ul className="navbar-nav">
					<li className="nav-item btn-rotate dropdown">
						<a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
						   aria-expanded="false">
							<i className="nc-icon nc-settings-gear-65"/>
						</a>
						<div className="dropdown-menu dropdown-menu-right"
							 aria-labelledby="navbarDropdownMenuLink">
							{items}
						</div>
					</li>
				</ul>
			</div>
		);
	}
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./React/src/components/main/Navbar.js